type Props = {
  message: string;
};

/**
 * システムエラーメッセージを共通スタイルで表示する最小部品。
 * @param param0 表示文言
 * @returns エラーメッセージ表示
 */
const SystemErrorMessage = ({ message }: Props) => {
  return <div className='m-text'>{message}</div>;
};

export default SystemErrorMessage;
